import React, { createContext, useContext, useMemo } from 'react';
import { useOktaAuth } from '@okta/okta-react';

const AuthContext = createContext(null);

export const ROLES = {
    ADMIN: 'admin',
    OPERATIONS: 'operations',
    PARTNER: 'partner',
  };

export const AuthProvider = ({ children }) => {
  const okta = useOktaAuth();
  const { authState: realAuthState, oktaAuth: realOktaAuth } = okta || {};

  const SKIP_OKTA = process.env.REACT_APP_SKIP_OKTA === 'true';
  const devUserName = process.env.REACT_APP_DEV_USER_NAME || 'Dev User';
  const devUserGroups = (process.env.REACT_APP_DEV_USER_GROUPS || 'brain-reporting-partners').split(',');

  const authState = SKIP_OKTA
    ? { isAuthenticated: true, idToken: { claims: { name: devUserName, groups: devUserGroups } } }
    : realAuthState;

  const oktaAuth = SKIP_OKTA
    ? { signOut: async () => {} }
    : realOktaAuth;

  const handleLogout = async () => {
    try {
      await oktaAuth.signOut({
        revokeAccessToken: true,
        revokeRefreshToken: false,
      });
    } catch (err) {
      console.error('Error during signOut:', err);
    }
  };

  // Role enum
  

  const mapGroupsToRole = (groups = []) => {
    const lowered = groups.map(g => String(g).toLowerCase());
    if (lowered.some(g => g.includes('partner') || g.includes('-partner'))) return ROLES.PARTNER;
    if (lowered.some(g => g.includes('ops') || g.includes('-ops') || g.includes('operations'))) return ROLES.OPERATIONS;
    if (lowered.some(g => g.includes('admin'))) return ROLES.ADMIN;
    return null;
  };

  const value = useMemo(() => {
    const user = authState?.idToken?.claims;
    const groups = user?.groups || [];
    const role = mapGroupsToRole(groups);

    console.log('AuthContext value computed:', { isAuthenticated: authState?.isAuthenticated, user, groups, role });

    return {
      isAuthenticated: authState?.isAuthenticated,
      user,
      groups,
      role,
      hasRole: (r) => {
        if (Object.values(ROLES).includes(r)) return r === role;
        return groups.includes(r);
      },
      handleLogout,
    };
  }, [authState, oktaAuth]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext) || {};
